module.exports = __webpack_public_path__ + "img/caselist26.62152efe.jpg";